/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import { Grid, Row, Col, Media,ControlLabel, FormControl, FormGroup } from "react-bootstrap";

import Card from "components/Card/Card.jsx";

import Button from "components/CustomButton/CustomButton.jsx";
import { registration } from "../../Listfunction";
import NotificationSystem from 'react-notification-system';
import {style} from "variables/Variables";

class RegisterPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
    email: "",
    password: "",
    cfpassword: "",
    emailError: null,
    passwordError: null,
    cfpasswordError: null,
    mobilenoError:null,
    nameError:null,
    name : "",
    mobileno : "",
    role : '0',
    roleError: null,
    errormessage : '',

  }
  this.onSubmit = this.onSubmit.bind(this);
  this.componentDidMount = this.componentDidMount.bind(this)

  this.onChange = this.onChange.bind(this);
}
componentDidMount()
{
  
  this.setState({_notificationSystem: this.refs.notificationSystem})
  setTimeout(
    function() {
      this.setState({ cardHidden: false }); 
    }.bind(this),
    700
  );
}
  handleEmailChange(event) {
    this.setState({
      email: event.target.value
    });
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    re.test(event.target.value) === false
      ? this.setState({
          emailError: (
            <small className="text-danger">
              Email is required and format should be <i>abc@def.com</i>.
            </small>
          )
        })
      : this.setState({ emailError: null });
  }
  hadlemobilenochange(event){
    this.setState({
      mobileno: event.target.value
    });
    var digitRex = /^\d+$/;
    digitRex.test(event.target.value) === false
      ? this.setState({
          mobilenoError: (
            <small className="text-danger">
              mobileno has to be a number.
            </small>
          )
        })
      : this.setState({ type_numberError: null });
  }
  handlenamechnage(event){
    this.setState({ name: event.target.value });
                              event.target.value === ""
                                ? this.setState({
                                    nameError: (
                                      <small className="text-danger">
                                        name is required.
                                      </small>
                                    )
                                  })
                                : this.setState({ type_textError: null });
                            }
  
  handlePasswordChange(event) {
    this.setState({
      password: event.target.value
    });
    event.target.value.length < 6
      ? this.setState({
          passwordError: (
            <small className="text-danger">
              You must enter a password of at least 6 characters.
            </small>
          )
        })
      : this.setState({ passwordError: null });
  }
  handleCfPasswordChange(event) {
    this.setState({
      cfpassword: event.target.value
    });
    event.target.value !== this.state.password
      ? this.setState({
          cfpasswordError: (
            <small className="text-danger">Passwords do not match.</small>
          )
        })
      : this.setState({ cfpasswordError: null });
  }
  onChange = (e) =>{
    this.setState({
    [e.target.name] : e.target.value
  })
  }
  handleSuccess(position){
    var color = Math.floor((Math.random() * 4) + 1);
    var level;
    switch (color) {
        case 1:
        level = 'success';
        break;
        case 2:
        level = 'warning';
        break;
        case 3:
        level = 'error';
        break;
        case 4:
        level = 'info';
        break;
        default:
        break;
    }
    level = 'success';
    this.state._notificationSystem.addNotification({
        title: (<span data-notify="icon" className="pe-7s-gift"></span>),
        message: (
            <div>
                 <b>User</b> - Added Successfully .
            </div>
        ),
        level: level,
        position: position,
        autoDismiss: 15,
    });
  }
  handleClick(position){
    var color = Math.floor((Math.random() * 4) + 1);
    var level;
    switch (color) {
        case 1:
        level = 'success';
        break;
        case 2:
        level = 'warning';
        break;
        case 3:
        level = 'error';
        break;
        case 4:
        level = 'info';
        break;
        default:
        break;
    }
    level = 'error';
    this.state._notificationSystem.addNotification({
        title: (<span data-notify="icon" className="pe-7s-gift"></span>),
        message: (
            <div>
                 <b>something went wrong</b>.
            </div>
        ),
        level: level,
        position: position,
        autoDismiss: 15,
    });
}
  onSubmit = (e) => {

    let error = false;
    if(this.state.name.length == 0)
    {error = true
       this.setState({
        nameError: (
            <small className="text-danger">
              Name is required.
            </small>
          )
        })
      }else{ this.setState({ nameError: null });}
      if(this.state.mobileno.length == 0)
      {error = true
         this.setState({
          mobilenoError: (
              <small className="text-danger">
                Mobile No is required.
              </small>
            )
          })
        }else{ this.setState({ mobilenoError: null });}
        if(this.state.email.length == 0)
        {error = true
           this.setState({
            emailError: (
                <small className="text-danger">
                  Email is required.
                </small>
              )
            })
          }else{ this.setState({ emailError: null });}
          if(this.state.password.length == 0)
          {error = true
             this.setState({
              passwordError: (
                  <small className="text-danger">
                    Password is required.
                  </small>
                )
              })
            }else{ this.setState({ passwordError: null });}
            if(this.state.cfpassword.length == 0)
            {error = true
               this.setState({
                cfpasswordError: (
                    <small className="text-danger">
                      Confirm Password  is required.
                    </small>
                  )
                })
              }else{ this.setState({ cfpasswordError: null });}
              if(this.state.role == 0)
              {error = true
                 this.setState({
                  roleError: (
                      <small className="text-danger">
                        Role is required.
                      </small>
                    )
                  })
                }else{ this.setState({ roleError: null });}
      if(!error)
      {
    registration(this.state.name,this.state.mobileno,this.state.email,this.state.password,this.state.cfpassword,this.state.role)
    .then((res)=>{
      if(res.data.success === false)
      {
      this.handleClick('bl')
    const message = res.data.data

      
      }
      else if(res.data.success === true)
      {
        this.handleSuccess('bl')
        this.setState({
            name : '',
            mobileno : '',
            email : '',
            role : '0',
            password : '',
            cfpassword :'',
        })
      }
   })
  }
  
  }
  render() {
    const errormessage = this.state.errormessage;

    return (
      <Grid>
        <NotificationSystem ref="notificationSystem" style={style}/>

        <Row>
          <Col md={8} mdOffset={2}>
            <div className="header-text">
              {/* <h2>Light Bootstrap Dashboard PRO</h2> */}
              <h4>Registration </h4>
              <hr />
            </div>
          </Col>
          <Col md={4} mdOffset={4}>
            <form onSubmit={this.onSubmit}>

              <Card
                plain
                content={
                  <div>
                  {errormessage.length == "1"? <div className='form-control alert alert-danger'> {errormessage}</div> : ''}

                   <FormGroup>
                    {/* <ControlLabel >Name</ControlLabel> */}
                      <FormControl type="text"
                      onChange={event => this.handlenamechnage(event)} required name="name" value={this.state.name || ''}
                      placeholder="Your  Name" />
                      {this.state.nameError}
                    </FormGroup>
                    <FormGroup>
                    {/* <ControlLabel>Email</ControlLabel> */}
                      <FormControl type="email"  
                      onChange={event => this.handleEmailChange(event)}
                      value={this.state.email || ''}
                      placeholder="Your email Name" autoComplete="off" />
                    {this.state.emailError}
                    </FormGroup>
                    
                    <FormGroup>
                    {/* <ControlLabel>Mobile No</ControlLabel> */}
                      <FormControl type="text" placeholder="Your MobileNo" 
                      onChange={event => this.hadlemobilenochange(event)} name="mobileno" value={this.state.mobileno || ''} autoComplete="off"/>
                      {this.state.mobilenoError}
                    </FormGroup>
                    <FormGroup>
                    {/* <ControlLabel>Password</ControlLabel> */}
                      <FormControl type="password" placeholder="Enter Password"
                      onChange={event => this.handlePasswordChange(event)}
                      value={this.state.password}
                      autoComplete="off" />
                    {this.state.passwordError}
                    </FormGroup>
                    
                    <FormGroup>
                    {/* <ControlLabel>Confirm Password</ControlLabel> */}
                      <FormControl type="password"
                      onChange={event => this.handleCfPasswordChange(event)}
                      value = {this.state.cfpassword}
                      placeholder="Enter Confirm Password" autoComplete="off"/>
                    {this.state.cfpasswordError}
                    </FormGroup>
                    
                    <FormGroup>
                    {/* <ControlLabel>Role</ControlLabel> */}
                    <select name="role" value={this.state.role} onChange={event => {
                        this.setState({ role: event.target.value });
                        event.target.value === "0"
                          ? this.setState({
                              roleError: (
                                <small className="text-danger">
                                  Role is required.
                                </small>
                              )
                            })
                          : this.setState({ roleError: null });
                      }} className="form-control">
                        <option value="0">Select Role</option>
                        <option value="1">Super Admin</option>
                        <option value="2">Admin</option>
                        <option value="3">User</option>
                        <option value="4">Third Party</option>
                        <option value="5">Rider</option>
                    </select>
                    {this.state.roleError}
                    </FormGroup>
                
                  </div>
                }
                ftTextCenter
                legend={
                  <Button bsStyle="info"  onClick={this.onSubmit.bind(this)} wd fill neutral >
                    Submit
                  </Button>
                }
              />
            </form>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default RegisterPage;
